<template>
  <div id="read">
    <nav-bar>
      <span slot="leftSpan">Books</span>
      <input
        slot="center"
        class="search"
        type="text"
        placeholder="书山有路勤为径,学海无涯苦作舟"
        v-model="inputValue"
        @keyup.enter="addItem"
      />
      <span slot="rightSpan">📖</span>
    </nav-bar>
    <task-bar>
      <is-read
        slot="tagging"
        :todo="todo"
        @reClick="change"
        :todoWord="[
          '未看' + '(' + todoCount + ')',
          '已看' + '(' + doneCount + ')',
        ]"
      ></is-read>
      <span v-if="!todoCount && todo">快来添加你想看的书籍吧</span>
      <span v-if="!doneCount && !todo">你还没有看完的书籍哦</span>
      <transition-group name="ani">
        <list-item
          v-for="(item, index) in myBooks"
          v-show="todo && !item.done"
          :item="item.title"
          :done="item.done"
          :key="item.tid"
          @deleteItem="deleteItem(index)"
          @isDone="isDone(index)"
        ></list-item>
      </transition-group>

      <transition-group name="ani">
        <list-item
          v-for="(item, index) in myBooks"
          v-show="!todo && item.done"
          :item="item.title"
          :done="item.done"
          :key="item.tid"
          @deleteItem="deleteItem(index)"
          @isDone="isDone(index)"
        ></list-item>
      </transition-group>
    </task-bar>
  </div>
</template>

<script>
import NavBar from "components/common/navbar/NavBar.vue";
import TaskBar from "components/content/taskbar/TaskBar.vue";
import ListItem from "components/content/listItem/ListItem.vue";
import IsRead from "components/common/isRead/IsRead.vue";

import { getData, saveData, deleteData } from "assets/js/todoList.js";

export default {
  name: "Read",
  components: {
    NavBar,
    TaskBar,
    ListItem,
    IsRead,
  },
  data() {
    return {
      todo: true,
      myBooks: [],
      inputValue: "",
    };
  },
  computed: {
    //未完成数量
    todoCount() {
      return this.myBooks.filter((item) => {
        return !item.done;
      }).length;
    },

    //已完成数量
    doneCount() {
      return this.myBooks.filter((item) => {
        return item.done;
      }).length;
    },
  },
  // 页面加载即渲染所有数据
  created() {
    let allList = getData("myBooks");
    this.myBooks = allList;
  },
  // 监听数据变化
  watch: {
    myBooks: {
      handler() {
        saveData(this.myBooks, "myBooks");
      },
      deep: true, //深监听
    },
  },
  methods: {
    addItem(e) {
      let data = e.target.value;
      if (data === "") {
        return alert("请输入想看的书籍");
      }
      this.myBooks.push({
        title: data,
        done: false,
        tid: new Date().valueOf(),
      });
      this.inputValue = "";
    },
    change() {
      this.todo = !this.todo;
    },
    deleteItem(index) {
      this.myBooks.splice(index, 1);
    },
    isDone(index) {
      this.myBooks[index].done = !this.myBooks[index].done;
    },
  },
};
</script>

<style scoped lang="less"></style>
